var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn",
    clipPath: "url(#clip0_181_585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19.98 0.0161133H5.97998C3.21898 0.0161133 0.97998 2.25511 0.97998 5.01611V19.0161C0.97998 21.7771 3.21898 24.0161 5.97998 24.0161H19.98C22.742 24.0161 24.98 21.7771 24.98 19.0161V5.01611C24.98 2.25511 22.742 0.0161133 19.98 0.0161133ZM8.97998 19.0161H5.97998V8.01611H8.97998V19.0161ZM7.47998 6.74811C6.51398 6.74811 5.72998 5.95811 5.72998 4.98411C5.72998 4.01011 6.51398 3.22011 7.47998 3.22011C8.44598 3.22011 9.22998 4.01011 9.22998 4.98411C9.22998 5.95811 8.44698 6.74811 7.47998 6.74811ZM20.98 19.0161H17.98V13.4121C17.98 10.0441 13.98 10.2991 13.98 13.4121V19.0161H10.98V8.01611H13.98V9.78111C15.376 7.19511 20.98 7.00411 20.98 12.2571V19.0161Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.97998 0.0161133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.997b26cd7337fa6d2d35ef13a2fddc78.svg";
export { ForwardRef as ReactComponent };